var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebPageIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M3.5 21.5c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 1.5 19.5v-15c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 3.5 2.5h17c.55 0 1.02.196 1.413.587.391.392.587.863.587 1.413v15c0 .55-.196 1.02-.587 1.413a1.926 1.926 0 0 1-1.413.587h-17z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M3.5 19.5h17v-12h-17z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M12.75 17.63H17v-1.75h-4.25v1.75zm0-3.255h6v-1.75h-6v1.75zm0-3.255h6V9.37h-6v1.75zM11 9.25v8.5H5.25v-8.5H11z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M4.5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM8 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3.5 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-2.25 5H7v5h2.25v-5z"
}))));
export default SvgWebPageIcon;